/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Image_Pod_Automation_Work_0_DescInputs */

const en_svc_ai_image_pod_automation_work_0_desc = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automated product pipelines that keep listings fresh across channels, synced live around the clock.`)
};

const ar_svc_ai_image_pod_automation_work_0_desc = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`خطوط منتجات مؤتمتة تبقي القوائم حديثة عبر القنوات، متزامنة مباشرة على مدار الساعة.`)
};

const bn_svc_ai_image_pod_automation_work_0_desc = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`স্বয়ংক্রিয় পণ্য পাইপলাইন চ্যানেলে লিস্টিং তাজা রাখে, সারাদিন লাইভ সিঙ্ক।`)
};

const de_svc_ai_image_pod_automation_work_0_desc = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatisierte Produkt-Pipelines, die Listings über Kanäle frisch halten, live und rund um die Uhr synchronisiert.`)
};

const es_svc_ai_image_pod_automation_work_0_desc = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pipelines de producto automatizados que mantienen los anuncios frescos entre canales, sincronizados en vivo todo el día.`)
};

const fr_svc_ai_image_pod_automation_work_0_desc = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des pipelines de produits automatisés qui gardent les annonces fraîches entre canaux, synchronisées en direct jour et nuit.`)
};

const pt_svc_ai_image_pod_automation_work_0_desc = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pipelines de produto automatizados que mantêm os anúncios frescos entre canais, sincronizados ao vivo o dia todo.`)
};

const zh_svc_ai_image_pod_automation_work_0_desc = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自动化产品管道让各渠道 listing 保持新鲜，全天实时同步。`)
};

const tr_svc_ai_image_pod_automation_work_0_desc = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listelemeleri kanallar arası taze tutan otomatik ürün hatları, gün boyu canlı senkronlu.`)
};

const ru_svc_ai_image_pod_automation_work_0_desc = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автоматизированные продуктовые пайплайны держат листинги свежими между каналами, синхронно вживую круглые сутки.`)
};

const pl_svc_ai_image_pod_automation_work_0_desc = /** @type {(inputs: Svc_Ai_Image_Pod_Automation_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zautomatyzowane potoki produktów trzymają listingi świeże między kanałami, synchronizowane na żywo całą dobę.`)
};

/**
* | output |
* | --- |
* | "Automated product pipelines that keep listings fresh across channels, synced live around the clock." |
*
* @param {Svc_Ai_Image_Pod_Automation_Work_0_DescInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_image_pod_automation_work_0_desc = /** @type {((inputs?: Svc_Ai_Image_Pod_Automation_Work_0_DescInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Image_Pod_Automation_Work_0_DescInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_image_pod_automation_work_0_desc(inputs)
	if (locale === "bn") return bn_svc_ai_image_pod_automation_work_0_desc(inputs)
	if (locale === "de") return de_svc_ai_image_pod_automation_work_0_desc(inputs)
	if (locale === "es") return es_svc_ai_image_pod_automation_work_0_desc(inputs)
	if (locale === "fr") return fr_svc_ai_image_pod_automation_work_0_desc(inputs)
	if (locale === "pt") return pt_svc_ai_image_pod_automation_work_0_desc(inputs)
	if (locale === "zh") return zh_svc_ai_image_pod_automation_work_0_desc(inputs)
	if (locale === "tr") return tr_svc_ai_image_pod_automation_work_0_desc(inputs)
	if (locale === "ru") return ru_svc_ai_image_pod_automation_work_0_desc(inputs)
	if (locale === "pl") return pl_svc_ai_image_pod_automation_work_0_desc(inputs)
	return en_svc_ai_image_pod_automation_work_0_desc(inputs)
});
export { svc_ai_image_pod_automation_work_0_desc as "svc_ai-image-pod-automation_work_0_desc" }